import axios from '@fs/zion-axios'

const BASE_TREE_SPROUT_PATH = '/service/dmc/treeSprout'

export async function treeSync(cisId) {
  const response = await axios.post(`${BASE_TREE_SPROUT_PATH}/${cisId}/treeSync`)
  return response.data
}

export async function getTreeSyncStatus(cisId) {
  const response = await axios.get(`${BASE_TREE_SPROUT_PATH}/${cisId}/treeSyncStatus`)
  return response.data
}
